import {
  SalaryCardActions,
  SalaryCardActionTypes,
  SalaryCardState,
} from 'store/types/salaryCard'

const initialState: SalaryCardState = {
  trustedPersonList: [],
  trustedPerson: null,
  trustedStatus: 'idle',
  trustedByPinStatus: 'idle',
}

export const trustedPersonReducers = (
  state = initialState,
  action: SalaryCardActions
): SalaryCardState => {
  switch (action.type) {
    case SalaryCardActionTypes.FETCH_TRUSTED_PERSON_REQUEST:
      return {
        ...state,
        trustedStatus: 'loading',
      }
    case SalaryCardActionTypes.FETCH_TRUSTED_PERSON_SUCCESS:
      return {
        ...state,
        trustedStatus: 'success',
        trustedPersonList: action.payload,
      }
    case SalaryCardActionTypes.FETCH_UPDATE_TRUSTED_PERSON_SUCCESS:
      return {
        ...state,
        trustedStatus: 'success',
        trustedPersonList: state.trustedPersonList.map((person) =>
          person.id === action.payload.id
            ? { ...person, ...action.payload }
            : person
        ),
      }
    case SalaryCardActionTypes.FETCH_DELETE_TRUSTED_PERSON_SUCCESS:
      return {
        ...state,
        trustedStatus: 'success',
        trustedPersonList: [
          ...state.trustedPersonList.filter((i) => i.id !== action.payload.id),
        ],
      }
    case SalaryCardActionTypes.FETCH_TRUSTED_PERSON_BY_PIN_REQUEST:
      return {
        ...state,
        trustedByPinStatus: 'loading',
      }
    case SalaryCardActionTypes.FETCH_TRUSTED_PERSON_BY_PIN_SUCCESS:
      return {
        ...state,
        trustedByPinStatus: 'success',
        trustedPerson: action.payload,
      }
    case SalaryCardActionTypes.FETCH_TRUSTED_PERSON_BY_PIN_FAILURE:
      return {
        ...state,
        trustedByPinStatus: 'failed',
      }
    case SalaryCardActionTypes.FETCH_TRUSTED_PERSON_FAILURE:
      return {
        ...state,
        trustedStatus: 'failed',
      }
    default:
      return state
  }
}
